<template>
<div>
    <router-link v-if="row.type == relatedMerchantType.GATEWAY" :to="'/stakeholders/update/' + row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fas fa-edit"></i>
    </router-link>
    <router-link v-else-if="row.type == relatedMerchantType.WALLET" :to="'/stakeholders/update-wallet-type/' + row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fas fa-edit"></i>
    </router-link>
    <router-link v-else-if="row.type == relatedMerchantType.PSP" :to="'/stakeholders/update-psp-type/' + row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fas fa-edit"></i>
    </router-link>
    <router-link v-if="row.type == relatedMerchantType.GATEWAY" :to="{name: 'stakeholders_shops_info', params: { hashid: row.id, stakeholder_type: row.type } }" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
        <i class="fas fa-info-circle"></i>
    </router-link>
</div>
</template>

<script>
import Vue from 'vue';
import { relatedMerchantType } from '@/constants/related_merchant_type';

export default Vue.extend({
    data() {
        return {
            relatedMerchantType: relatedMerchantType,
        };
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },
})
</script>
